__turbopack_context__.v({
  "formSuccessWrp": "quoteFormSuccess-module-scss-module__TaS9aa__formSuccessWrp",
  "promiseTextWrp": "quoteFormSuccess-module-scss-module__TaS9aa__promiseTextWrp",
  "resultContent": "quoteFormSuccess-module-scss-module__TaS9aa__resultContent",
  "resultWrp": "quoteFormSuccess-module-scss-module__TaS9aa__resultWrp",
  "thanksHeaderWrp": "quoteFormSuccess-module-scss-module__TaS9aa__thanksHeaderWrp",
});
